import type {SchemeLogoProps} from '../../CreditCardSchemeLogo.tsx';

export function MastercardLogo({className}: SchemeLogoProps) {
    return (
        <svg
            aria-label="Mastercard"
            className={className}
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="15" cy="23.9412" r="15" fill="#EB001B" />
            <circle cx="33" cy="23.9412" r="15" fill="#F79E1B" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M23.9999 35.9412C28.1407 33.5458 30.9266 29.0688 30.9266 23.9412C30.9266 18.8135 28.1407 14.3365 23.9999 11.9412C19.8592 14.3365 17.0733 18.8135 17.0733 23.9412C17.0733 29.0688 19.8592 33.5458 23.9999 35.9412Z"
                fill="#FF5F00"
            />
        </svg>
    );
}
